import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { url: String, turbo: Boolean, turboFrame: String }
  }

  connect() {
    if (this.hasTurboFrameValue || this.turboValue) {
      // Clear the Turbo cache to prevent issues
      Turbo.cache.clear()
    }

    if (this.hasTurboFrameValue) {
      Turbo.visit(this.urlValue, { frame: this.turboFrameValue })
    } else if (this.turboValue) {
      Turbo.visit(this.urlValue)
    } else {
      window.location = this.urlValue
    }
  }
}
